// Sentry — monitoramento de erros frontend.
// Init lazy; só ativa se VITE_SENTRY_DSN estiver setada.

import * as Sentry from '@sentry/react'

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const ENV = (import.meta.env.MODE === 'production' ? 'production' : 'development')

export function inicializarSentry() {
  if (!DSN || DSN.length < 10) {
    if (import.meta.env.PROD) {
      console.warn('[sentry] DSN não configurado — erros não serão reportados')
    }
    return
  }

  Sentry.init({
    dsn: DSN,
    environment: ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,        // Anamis: dados de saúde podem ser sensíveis;
        maskAllInputs: true,       // mascarar inputs (texto livre, senhas, ideação)
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: ENV === 'production' ? 0.2 : 1.0,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
    // Filtra erros conhecidos de bibliotecas third-party
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      // Service Worker reload
      'A new version is available. Refresh',
    ],
    beforeSend(event) {
      // Não envia eventos com dados de saúde no contexto
      // (filtragem leve — replay já mascara inputs)
      return event
    },
  })
}

/** Marca o user logado pra contextualizar erros no Sentry. */
export function setSentryUser(uid: string | null, role?: string) {
  if (!DSN) return
  if (!uid) {
    Sentry.setUser(null)
    return
  }
  Sentry.setUser({ id: uid, segment: role })
}

/** ErrorBoundary do Sentry pra capturar erros de render. */
export const SentryErrorBoundary = Sentry.ErrorBoundary
